import { i18n } from '@/plugins/i18n';

const CIMOB = {
  minarm_organism: 'CIMOB',
  minarm_organism_le: 'le CIMOB',
  minarm_organism_du: 'du CIMOB',
  minarm_organism_au: 'au CIMOB',
};

const CELLULE_GN = {
  minarm_organism: 'cellule PFMD de la GN',
  minarm_organism_le: 'la cellule PFMD de la GN',
  minarm_organism_du: 'de la cellule PFMD de la GN',
  minarm_organism_au: 'à la cellule PFMD de la GN',
};

export function updateMinarmOrganismMessages(isMinarmGN: boolean) {
  const messages = isMinarmGN ? CELLULE_GN : CIMOB;
  i18n.global.mergeLocaleMessage('fr', { base: messages });
}
